/**
 * 药品超量模块 请求 api
 */
// 引入工具函数
import req from '@/utils/request';

// 获取药品超量列表
export const drugExcessList = (params) => {
  return req.get('/hosp/drug/excess/list', params);
}

// 新增药品超量
export const drugExcessAdd = (params) => {
  return req.post('/hosp/drug/excess', params);
}

// 修改药品超量
export const drugExcessEdit = (params) => {
  return req.put('/hosp/drug/excess', params);
}

// 删除药品超量
export const drugExcessDelete = (drugExcessIds ) => {
  return req.delete(`/hosp/drug/excess/${drugExcessIds }`);
}